<!-- <div mat-dialog-title>
  <div class="icon-box">
    <i class="material-icons">&#xE5CD;</i>
  </div>
</div> -->
<child-header title="Delete confirmation" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content style="text-align: center">
  <h4>Are you sure?</h4>
  <p>This process cannot be undone</p>
</div>
<div mat-dialog-actions>
  <button mat-button class="button button-red button-mid button-left" (click)="onNoClick()">Cancel</button>
  <button mat-button class="button button-red button-mid" (click)="confirmDelete()">Delete</button>
</div>